export default {
  root: {
    '&.Mui-expanded': {
      margin: '1px 0'
    }
  }
};
